import { Theme, makeStyles } from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { hexToRGB } from "@tuqqi/common";
import React from "react";
import { useTranslation } from "react-i18next";


interface Props {
    useTop?: boolean
    value: string
    focused: boolean
    popupRef: React.RefObject<HTMLDivElement>
    onSelect: (o: string) => void
    options: string[]
}

const styles = (theme: Theme) => ({
    containerTop: {
        bottom: 36
    },
    containerBottom: {
        top: 36,
    },
    container: {
        zIndex: 1,
        marginTop: 8,
        position: 'absolute',
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 2px 8px rgba(27, 30, 42, 0.24)',
        borderRadius: 4,
    } as CSSProperties,
    placeholder: {
        padding: 24,
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    } as CSSProperties,
    row: {
        display: 'flex',
        flexDirection: 'row'
    } as CSSProperties,
    placeholderText: {
        // fontFamily: 'Rubik',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '20px',
        textAlign: 'center',
        letterSpacing: 0.246063,
        color: '#0C0C0D',
    } as CSSProperties,
    placeholderValText: {
        // fontFamily: 'Rubik',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '20px',
        textAlign: 'center',
        letterSpacing: 0.246063,
        color: '#0C0C0D',
    } as CSSProperties,
    options: {
        paddingTop: 4,
        paddingBottom: 4,
    },
    option: {
        cursor: 'pointer',
        paddingLeft: 12,
        paddingRight: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minHeight: 20,
        paddingTop: 8,
        paddingBottom: 8,
        '&:hover': {
            background: hexToRGB(theme.palette.primary.main, 0.08)
        }
    },
    optionText: {
        display: 'flex',
        // fontFamily: 'Rubik',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '20px',
        textAlign: 'justify',
        letterSpacing: 0.25,
        color: '#0C0C0D',
    }  as CSSProperties
})
const useStyles = makeStyles(styles)

export const SuggestionsLocationPopover = (props: Props) => {
    const classes = useStyles()
    const {options, value, focused, onSelect, popupRef, useTop} = props
    const [t] = useTranslation("i18_fullview")

    const PlaceholderValue = <span className={classes.placeholderValText}>{value}</span>

    const Placeholder = <div data-intrcm-id="SuggestionsLocationPopover_tq5iwfqa" className={classes.placeholder}>
        <div data-intrcm-id="SuggestionsLocationPopover_q5i1c35u" className={classes.row}>
            {!!value ? 
                <span className={classes.placeholderText}>{t('There is no')}{' "'}{PlaceholderValue}{'"'}{` ${t("address")}.`}</span> :
                <span className={classes.placeholderText}>{t('Search an address')}</span>
            }
        </div>
    </div>

    const renderOption = (x: string, i: number) => {
        return <div data-intrcm-id="SuggestionsLocationPopover_3gw3nagn" onClick={() => onSelect(x)} key={i} className={classes.option}>
            <div data-intrcm-id="SuggestionsLocationPopover_sdi78u2w" className={classes.optionText}>{x}</div>
        </div>
    }

    if(!focused) return null

    const Content = !options.length ? 
        Placeholder :
        <>
            <div data-intrcm-id="SuggestionsLocationPopover_a1eospoy" className={classes.options}>
                {options.map((option, i) => renderOption(option, i))}
            </div>
        </>

    return <div data-intrcm-id="SuggestionsLocationPopover_94ntkpmp" ref={popupRef} className={`${classes.container} ${useTop ? classes.containerTop : classes.containerBottom}`}>
        {Content}
    </div>
}